let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6ojIT")).then(() => parcelRequire('3cErl'));